module.exports = __webpack_public_path__ + "img/0Q3A7692_L_WoodMatted_MockedUp.cf104199.jpg";